import { getInitials } from "../utils/formatters";
import { cx } from "../utils/cx";

function UserAvatar({ name, status = "Active", className }) {
  const normalizedStatus = String(status || "").trim().toLowerCase();
  const isPositiveStatus = normalizedStatus === "online" || normalizedStatus === "active";

  return (
    <span className={cx("user-avatar", className)}>
      <span>{getInitials(name)}</span>
      <span
        aria-label={status}
        className={cx(
          "user-avatar-status",
          isPositiveStatus ? "is-online" : "is-offline"
        )}
      />
    </span>
  );
}

export default UserAvatar;
